import { createFileRoute } from "@tanstack/react-router";
import { ProductEditPage } from "../../../components/products/ProductEditPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/products/$productId/edit")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: ProductEditRoute,
});

function ProductEditRoute() {
  const { productId } = Route.useParams();
  return <ProductEditPage productId={productId} />;
}
